import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {JwtModule} from '@auth0/angular-jwt';
import {FlexLayoutModule} from "@angular/flex-layout";

import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {TimeTicketComponent} from './time-ticket/time-ticket.component';
import {IsUserGuard} from './guards/is-user.guard';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TimeTicketComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'ng-cli-universal'}),
    HttpClientModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    FlexLayoutModule,
    RouterModule.forRoot([
      {path: 'time-ticket', component: TimeTicketComponent, canActivate: [IsUserGuard]},
      {path: 'login', component: LoginComponent},
      {path: '', redirectTo: '/login', pathMatch: 'full'},
      {path: '**', redirectTo: '/login'},
    ]),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('access_token');
        },
        disallowedRoutes: ['auth/login'],
      },
    }),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
